/**
 * 收入详情刷新
 */
const INCOME_DETAIL_REFRESH = 'income_detail_refresh'

/**
 * 成本详情刷新
 */
const COST_DETAIL_REFRESH = 'cost_detail_refresh'

/**
 * 件杂货 - 库存更新
 */
const BULK_STOCK_REFRESH = 'bulk_stock_refresh'

export default {
  INCOME_DETAIL_REFRESH,
  COST_DETAIL_REFRESH,
  BULK_STOCK_REFRESH
}
